import { Component } from '@angular/core';

@Component({
  selector: 'app-fieldset-accordion-header',
  templateUrl: './fieldset-accordion-header.component.html',
})
export class FieldsetAccordionHeaderComponent { }
